/*
 * MSCVTR — gedrag van de header (Horizon-migratie, pakket 4, 20-10-2026). Nieuw geschreven.
 *  - mega-menu en dropdown: open bij hover (muis) en bij toetsenbordfocus; Escape sluit en zet de focus terug
 *  - zoekpaneel met Shopify's predictive search (sections/mscvtr-zoekresultaten.liquid)
 *  - --header-height / --header-group-height op <body> (Horizon en eigen sticky-onderdelen rekenen daarmee)
 *  - teller op het winkelwagenicoon bij elke cart-wijziging (event 'cart:change' uit mscvtr-componenten.js)
 */
(() => {
  if (window.MSCVTR_HEADER) return;
  window.MSCVTR_HEADER = true;

  const kanHover = () => window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* ── Hoogtes ─────────────────────────────────────────────────────────────────── */
  const meetHoogtes = () => {
    const header = document.querySelector('[data-mscvtr-header]');
    const groep = document.getElementById('header-group');
    if (!header) return;
    const balk = header.querySelector('.mscvtr-header__balk');
    let groepHoogte = 0;
    if (groep) {
      for (const el of groep.children) if (el instanceof HTMLElement) groepHoogte += el.offsetHeight;
    }
    document.body.style.setProperty('--header-height', `${(balk || header).offsetHeight}px`);
    document.body.style.setProperty('--header-group-height', `${groepHoogte}px`);
  };

  /* ── Menu ────────────────────────────────────────────────────────────────────── */
  let open = null;
  let sluitTimer = null;
  let onderdruk = false; // focus terugzetten na Escape mag het paneel niet weer openen

  const zet = (item, aan) => {
    if (!item) return;
    const link = item.querySelector(':scope > [data-mscvtr-nav-open]');
    const paneel = item.querySelector(':scope > [data-mscvtr-nav-paneel]');
    if (!link || !paneel) return;
    paneel.hidden = !aan;
    link.setAttribute('aria-expanded', aan ? 'true' : 'false');
    item.classList.toggle('is-open', aan);
    document.querySelector('[data-mscvtr-header]')?.classList.toggle('is-menu-open', aan);
  };
  const openItem = (item) => {
    clearTimeout(sluitTimer);
    if (open && open !== item) zet(open, false);
    open = item;
    zet(item, true);
  };
  const sluitAlles = ({ focus = false } = {}) => {
    clearTimeout(sluitTimer);
    if (!open) return;
    const item = open;
    zet(item, false);
    open = null;
    if (focus) {
      onderdruk = true;
      item.querySelector(':scope > .mscvtr-nav__link')?.focus();
      onderdruk = false;
    }
  };

  document.addEventListener('mouseover', (e) => {
    if (!kanHover()) return;
    const item = e.target.closest('.mscvtr-nav__item');
    if (item && item.querySelector(':scope > [data-mscvtr-nav-paneel]')) {
      clearTimeout(sluitTimer);
      if (open !== item) sluitTimer = setTimeout(() => openItem(item), open ? 0 : 80);
      return;
    }
    if (item) { sluitTimer = setTimeout(() => sluitAlles(), 120); return; }
    if (open && !e.target.closest('.mscvtr-nav__item')) {
      clearTimeout(sluitTimer);
      sluitTimer = setTimeout(() => sluitAlles(), 180);
    }
  });

  // Toetsenbord: focus op een menu-item opent het paneel; focus elders sluit het.
  document.addEventListener('focusin', (e) => {
    if (onderdruk) return;
    const item = e.target.closest('.mscvtr-nav__item');
    if (item && item.querySelector(':scope > [data-mscvtr-nav-paneel]')) { openItem(item); return; }
    if (open && !open.contains(e.target)) sluitAlles();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    if (open) { sluitAlles({ focus: true }); return; }
    const zoek = document.querySelector('[data-mscvtr-zoek]');
    if (zoek && !zoek.hidden) zoekDicht({ focus: true });
  });

  // Touchscreen breed genoeg voor het desktopmenu: eerste tik opent, tweede tik volgt de link.
  document.addEventListener('click', (e) => {
    const link = e.target.closest('[data-mscvtr-nav-open]');
    if (!link || kanHover()) return;
    const item = link.closest('.mscvtr-nav__item');
    if (open !== item) { e.preventDefault(); openItem(item); }
  });
  document.addEventListener('click', (e) => {
    if (open && !e.target.closest('.mscvtr-nav__item')) sluitAlles();
  });

  /* ── Zoeken ──────────────────────────────────────────────────────────────────── */
  let zoekOpener = null;
  let zoekController = null;
  let zoekTimer = null;

  const zoekOpen = (opener) => {
    const paneel = document.querySelector('[data-mscvtr-zoek]');
    if (!paneel) return;
    sluitAlles();
    zoekOpener = opener || document.activeElement;
    paneel.hidden = false;
    document.querySelectorAll('[aria-controls="mscvtr-zoekpaneel"]').forEach((k) => k.setAttribute('aria-expanded', 'true'));
    document.querySelector('[data-mscvtr-header]')?.classList.add('is-zoek-open');
    paneel.querySelector('[data-mscvtr-zoek-veld]')?.focus();
  };
  const zoekDicht = ({ focus = false } = {}) => {
    const paneel = document.querySelector('[data-mscvtr-zoek]');
    if (!paneel || paneel.hidden) return;
    paneel.hidden = true;
    document.querySelectorAll('[aria-controls="mscvtr-zoekpaneel"]').forEach((k) => k.setAttribute('aria-expanded', 'false'));
    document.querySelector('[data-mscvtr-header]')?.classList.remove('is-zoek-open');
    if (focus) zoekOpener?.focus?.();
  };

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-mscvtr-zoek-open]');
    if (opener) {
      e.preventDefault();
      const paneel = document.querySelector('[data-mscvtr-zoek]');
      if (paneel && !paneel.hidden) zoekDicht(); else zoekOpen(opener);
      return;
    }
    if (e.target.closest('[data-mscvtr-zoek-sluit]')) { zoekDicht({ focus: true }); return; }
    const paneel = document.querySelector('[data-mscvtr-zoek]');
    if (paneel && !paneel.hidden && !e.target.closest('[data-mscvtr-zoek]') && !e.target.closest('.mscvtr-bewaard')) zoekDicht();
  });

  const zoekOp = async (term) => {
    const doel = document.querySelector('[data-mscvtr-zoek-resultaten]');
    if (!doel) return;
    if (!term.trim()) { doel.innerHTML = ''; return; }
    zoekController?.abort();
    zoekController = new AbortController();
    const root = window.Shopify?.routes?.root || '/';
    const url = `${root}search/suggest?q=${encodeURIComponent(term)}&resources[type]=product,query&resources[limit]=10&resources[limit_scope]=each&resources[options][unavailable_products]=last&section_id=mscvtr-zoekresultaten`;
    try {
      const res = await fetch(url, { signal: zoekController.signal });
      if (!res.ok) return;
      const html = await res.text();
      const tijdelijk = new DOMParser().parseFromString(html, 'text/html');
      const inhoud = tijdelijk.querySelector('.mscvtr-zoekres');
      doel.innerHTML = inhoud ? inhoud.outerHTML : '';
    } catch (err) {
      if (err.name !== 'AbortError') doel.innerHTML = '';
    }
  };

  document.addEventListener('input', (e) => {
    if (!e.target.matches('[data-mscvtr-zoek-veld]')) return;
    clearTimeout(zoekTimer);
    const term = e.target.value;
    zoekTimer = setTimeout(() => zoekOp(term), 220);
  });

  /* ── Winkelwagenteller ───────────────────────────────────────────────────────── */
  const zetTeller = (aantal) => {
    document.querySelectorAll('[data-mscvtr-cart-aantal]').forEach((el) => {
      el.textContent = aantal;
      el.hidden = !aantal;
    });
  };
  document.addEventListener('cart:change', (e) => {
    const cart = e.detail && e.detail.cart;
    if (cart && typeof cart.totalQuantity === 'number') zetTeller(cart.totalQuantity);
    else fetch(`${window.Shopify?.routes?.root || '/'}cart.js`).then((r) => r.json()).then((c) => zetTeller(c.item_count)).catch(() => {});
  });
  // Terug via de knop "vorige" (bfcache): teller opnieuw ophalen.
  window.addEventListener('pageshow', (e) => {
    if (e.persisted) fetch(`${window.Shopify?.routes?.root || '/'}cart.js`).then((r) => r.json()).then((c) => zetTeller(c.item_count)).catch(() => {});
  });

  /* ── Start ───────────────────────────────────────────────────────────────────── */
  const start = () => {
    meetHoogtes();
    if ('ResizeObserver' in window) {
      const header = document.querySelector('[data-mscvtr-header]');
      if (header) new ResizeObserver(meetHoogtes).observe(header);
    }
    window.addEventListener('resize', meetHoogtes, { passive: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', meetHoogtes);
})();
